import CandidatesNavItemLabel from './CandidatesNavItemLabel'

export default CandidatesNavItemLabel
